import * as React from "react";
import styled from "styled-components";
import { Layout, Menu, Row, Col, Icon } from "antd";
import { ForwardMenuItem } from "./ForwardMenuItem";
import logoSVG from "../assets/forward_logo.svg";
import { ReactComponent as IconDirect } from "../assets/icons/icon_direct.svg";
import { ReactComponent as IconMulti } from "../assets/icons/icon_multi.svg";
import { ReactComponent as IconTruck } from "../assets/icons/icon_truck.svg";
import { ReactComponent as IconAddressbook } from "../assets/icons/icon_addressbook.svg";
import { ReactComponent as IconInvoice } from "../assets/icons/icon_invoice.svg";
import { ReactComponent as IconSettings } from "../assets/icons/icon_settings.svg";
import { ReactComponent as IconRecurring } from "../assets/icons/icon_recurring.svg";

const { Sider } = Layout;

type SidebarProps = {
  collapsed: boolean;
  isResponsive: boolean;
};

const StyledSider = styled(Sider)`
  height: 100vh !important;
  background: white !important;
  padding: ${(props: SidebarProps) =>
    props.isResponsive && props.collapsed ? "0" : "90px 38px 0 38px"};
  position: fixed !important;
  z-index: 100;

  .logo_icon {
    margin-bottom: 80px;
    width: 160px;
  }

  .ant-layout-sider-zero-width-trigger.ant-layout-sider-zero-width-trigger-left {
    display: none;
  }

  :after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: ${(props: SidebarProps) =>
      props.isResponsive ? "none" : "100vh solid white"};
    border-right: ${(props: SidebarProps) =>
      props.isResponsive ? "none" : "105px solid transparent"};
    top: 0%;
    left: 100%;
  }

  @media only screen and (max-width: 1200px) {
    position: absolute !important;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  }

  @media only screen and (max-width: 567px) {
    .logo_icon {
      margin-bottom: 20px;
    }
  }
`;

const ContactWrapper = styled.div`
  position: absolute;
  bottom: 80px;
  left: 37px;
  visibility: ${(props: { collpased: boolean }) =>
    props.collpased ? "hidden" : "visible"};
`;

const ContactInfo = styled.span`
  font-weight: 400;
  font-size: 13px;
  line-height: 17px;
  color: #386ee8;
`;

const ContactLink = styled.a`
  font-weight: 400;
  font-size: 13px;
  line-height: 17px;
  color: #061a32;
  &:hover {
    color: #386ee8;
  }
`;

const DrawerHandle = styled.div`
  position: absolute;
  top: 72px;
  width: 41px;
  height: 40px;
  cursor: pointer;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  right: -40px;
  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  border-radius: 0 4px 4px 0;
  visibility: ${(props: { isResponsive: boolean }) =>
    props.isResponsive ? "visible" : "hidden"};
`;

export const ForwardSider = () => {
  const [isCollapsed, setCollpased] = React.useState(false);
  const [isResponsive, setResponsive] = React.useState(false);

  return (
    <StyledSider
      width={235}
      collapsible
      collapsed={isCollapsed}
      collapsedWidth={0}
      breakpoint="xl"
      onBreakpoint={broken => {
        setResponsive(broken);
        setCollpased(broken);
      }}
      isResponsive={isResponsive}
    >
      <Row
        type="flex"
        justify="space-between"
        style={{ height: "100%", flexDirection: "column" }}
      >
        {/* top part (logo and menu) */}
        <Col span={24}>
          <Row type="flex">
            <Col span={24}>
              <img className="logo_icon" src={logoSVG} alt="logo" />
            </Col>
            <Col span={24}>
              <Menu style={{ border: "none" }}>
                <ForwardMenuItem
                  icon={<IconDirect />}
                  title="Direktfahrt"
                  path="/"
                />
                <ForwardMenuItem
                  icon={<IconMulti />}
                  title="Multi-Stopp"
                  path="/multi"
                />
                <ForwardMenuItem
                  icon={<IconRecurring />}
                  title="Regelmäßig"
                  path="/recurring"
                />
                <ForwardMenuItem
                  icon={<IconTruck />}
                  title="Alle Fahrten"
                  path="/orders"
                />
                <ForwardMenuItem
                  icon={<IconAddressbook />}
                  title="Adressbuch"
                  path="/addresses"
                />
                <ForwardMenuItem
                  icon={<IconInvoice />}
                  title="Rechnungen"
                  path="/invoices"
                />
                <ForwardMenuItem
                  icon={<IconSettings />}
                  title="Einstellungen"
                  path="/settings"
                />
              </Menu>
            </Col>
          </Row>
        </Col>
        {/* bottom part (contact) */}
        <ContactWrapper collpased={isCollapsed}>
          <Row type="flex" justify="start" align="middle">
            <Col span={24}>
              <ContactInfo>
                Fragen zur Buchung? Rufen Sie <br /> uns gerne jederzeit an:
              </ContactInfo>
            </Col>
            <Col span={24} style={{ paddingTop: 10 }}>
              <ContactLink href="tel:+494087409121">
                <Icon type="phone" /> 040 874 091 21
              </ContactLink>
              <br />
              <ContactLink href="mailto:mail@forward-cargo.com">
                <Icon type="mail" /> mail@forward-cargo.com
              </ContactLink>
            </Col>
          </Row>
        </ContactWrapper>
      </Row>
      <DrawerHandle
        isResponsive={isResponsive}
        onClick={() => {
          document.body.style.overflow = isCollapsed ? "hidden" : "unset";
          setCollpased(!isCollapsed);
        }}
      >
        <Icon type={isCollapsed ? "menu" : "close"} />
      </DrawerHandle>
    </StyledSider>
  );
};
